'use client'

import { XIcon } from 'lucide-react'
import { Button } from '../button/Button'
import { paths } from '@/config/paths'
import Link from 'next/link'

interface TopBannerProps {
  onClose: () => void
}

export const TOP_BANNER_ID = 'top-banner-11'

export function TopBanner({ onClose }: TopBannerProps) {
  return (
    <>
      <div className="relative top-0 right-0 left-0 z-[100] flex w-full flex-col items-center justify-center gap-2 bg-primary p-2 text-center text-primary-foreground text-sm sm:flex-row">
        <p className="px-10">
          Migrate to Euler Markets Now with the Migration Wizard in the{' '}
          <Link href={paths.dashboardPooled} className="font-medium underline">
            Pooled Dashboard
          </Link>
        </p>

        <Button
          variant="icon"
          size="sm"
          className="-translate-y-1/2 absolute top-1/2 right-1.5"
          onClick={onClose}
          aria-label="Close"
        >
          <XIcon className="h-5 w-5" />
        </Button>
      </div>
    </>
  )
}
